import { render } from "./invoice-report.vue?vue&type=template&id=f23a597e&scoped=true"
import script from "./invoice-report.vue?vue&type=script&lang=js"
export * from "./invoice-report.vue?vue&type=script&lang=js"

import "./invoice-report.vue?vue&type=style&index=0&id=f23a597e&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f23a597e"]])

export default __exports__